// stories.js
(function() {
    function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
    function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  
    document.addEventListener('DOMContentLoaded', function() {
      var container = qs('.stories-container');
      if (!container) return;
  
      var stories = qsa('.story-thumb', container).map(function(btn) {
        return {
          thumbnail_url: btn.querySelector('img').src,
          video_url: btn.dataset.videoUrl,
          related_product_handle: btn.dataset.relatedHandle,
          share_url: btn.dataset.shareUrl
        };
      });
      if (!stories.length) return;
  
      var overlay = qs('.story-overlay', container);
      var videoWrapper = qs('.story-overlay__video-wrapper', overlay);
      var progressBar = qs('.story-overlay__progress-bar .progress-bar', overlay);
      var closeBtn = qs('.story-overlay__close', overlay);
      var navPrev = qs('.story-overlay__nav--prev', overlay);
      var navNext = qs('.story-overlay__nav--next', overlay);
      var shareBtn = qs('.story-overlay__share', overlay);
      var relatedProduct = qs('.story-overlay__related-product', overlay);
      var thumbs = qsa('.story-thumb', container);
      var current = 0, videoEl = null;

      // Controles de vídeo
      var volumeBtn = qs('.story-volume', overlay);
      var playPauseBtn = qs('.story-play-pause', overlay);
      
             // Estado dos controles
       var isMuted = false;
       var lastClickTime = 0;
  
             function openStory(idx) {
         current = idx;
         overlay.style.display = 'flex';
         thumbs.forEach((btn, i) => btn.classList.toggle('active', i === idx));
         renderStory(idx);
       }
  
             function closeStory() {
         overlay.style.display = 'none';
         if (videoEl) { videoEl.pause(); videoEl = null; }
         progressBar.style.width = '0';
       }
  
      function formatTime(seconds) {
        var mins = Math.floor(seconds / 60);
        var secs = Math.floor(seconds % 60);
        return mins + ':' + (secs < 10 ? '0' : '') + secs;
      }
  

  
      function toggleVolume() {
        if (!videoEl) return;
        isMuted = !isMuted;
        videoEl.muted = isMuted;
        
        // Atualizar ícone do volume
        var volumeIcon = volumeBtn.querySelector('svg');
        if (isMuted) {
          volumeIcon.innerHTML = `
            <polygon points="11,5 6,9 2,9 2,15 6,15 11,19 11,5"></polygon>
            <line x1="23" y1="9" x2="17" y2="15"></line>
            <line x1="17" y1="9" x2="23" y2="15"></line>
          `;
        } else {
          volumeIcon.innerHTML = `
            <polygon points="11,5 6,9 2,9 2,15 6,15 11,19 11,5"></polygon>
            <path d="M19.07 4.93C20.9447 6.80528 21.9979 9.34836 21.9979 12.18C21.9979 15.0116 20.9447 17.5547 19.07 19.43"></path>
            <path d="M15.54 8.46C16.4774 9.39764 17.0039 10.7537 17.0039 12.18C17.0039 13.6063 16.4774 14.9624 15.54 15.9"></path>
          `;
        }
      }

              function togglePlayPause() {
          if (!videoEl) return;
          
          // Debounce para evitar múltiplos cliques
          var now = Date.now();
          if (now - lastClickTime < 300) return;
          lastClickTime = now;
          
          if (videoEl.paused) {
            videoEl.play();
          } else {
            videoEl.pause();
          }
        }

      function updatePlayPauseIcon() {
        if (!videoEl || !playPauseBtn) return;
        
        var playPauseIcon = playPauseBtn.querySelector('svg');
        if (videoEl.paused) {
          // Mostrar ícone de play
          playPauseIcon.innerHTML = `
            <polygon points="5,3 19,12 5,21 5,3"></polygon>
          `;
          playPauseBtn.style.display = 'flex';
        } else {
          // Esconder ícone quando está reproduzindo
          playPauseBtn.style.display = 'none';
        }
      }
  

  
      function renderStory(idx) {
        var st = stories[idx];
        videoWrapper.innerHTML = '';
        var v = document.createElement('video');
        v.src = st.video_url;
        v.muted = isMuted; // Usar estado atual de mute
        v.autoplay = true;
        v.playsInline = true;
        v.preload = 'auto';
        v.controls = false; // Remover controles nativos
        v.style.width = '100%';
        v.style.height = '100%';
        v.style.objectFit = 'cover';
        videoWrapper.appendChild(v);
        videoEl = v;

        // Garantir que o vídeo inicie automaticamente
        v.addEventListener('loadedmetadata', function() {
          // Forçar o estado de mute correto
          v.muted = isMuted;
          console.log('loadedmetadata - muted:', v.muted, 'isMuted:', isMuted);
          
          v.play().catch(function(error) {
            console.log('Autoplay failed:', error);
            // Se autoplay falhar, tentar novamente
            setTimeout(function() {
              v.muted = isMuted; // Garantir estado correto antes de tentar novamente
              v.play().catch(function(e) {
                console.log('Second autoplay attempt failed:', e);
              });
            }, 100);
          });
        });

        // Event listeners adicionais para garantir estado de mute
        v.addEventListener('canplay', function() {
          v.muted = isMuted;
          console.log('canplay - muted:', v.muted, 'isMuted:', isMuted);
        });

        v.addEventListener('loadeddata', function() {
          v.muted = isMuted;
          console.log('loadeddata - muted:', v.muted, 'isMuted:', isMuted);
        });
  
        // Manter estado de mute, mas garantir que o primeiro vídeo tenha áudio
        if (current === 0) {
          isMuted = false;
        }
        // isMuted mantém o valor anterior para outros vídeos
        
        if (volumeBtn) {
          var volumeIcon = volumeBtn.querySelector('svg');
          if (isMuted) {
            volumeIcon.innerHTML = `
              <polygon points="11,5 6,9 2,9 2,15 6,15 11,19 11,5"></polygon>
              <line x1="23" y1="9" x2="17" y2="15"></line>
              <line x1="17" y1="9" x2="23" y2="15"></line>
            `;
          } else {
            volumeIcon.innerHTML = `
              <polygon points="11,5 6,9 2,9 2,15 6,15 11,19 11,5"></polygon>
              <path d="M19.07 4.93C20.9447 6.80528 21.9979 9.34836 21.9979 12.18C21.9979 15.0116 20.9447 17.5547 19.07 19.43"></path>
              <path d="M15.54 8.46C16.4774 9.39764 17.0039 10.7537 17.0039 12.18C17.0039 13.6063 16.4774 14.9624 15.54 15.9"></path>
            `;
          }
        }
        if (playPauseBtn) {
          playPauseBtn.style.display = 'none';
        }
  
        v.addEventListener('timeupdate', function() {
          var pct = (v.currentTime / v.duration) * 100;
          progressBar.style.width = pct + '%';
        });
  
                 v.addEventListener('ended', function() {
           if (current < stories.length - 1) {
             openStory(current + 1);
           } else {
             // Navegação circular: último story -> primeiro story
             openStory(0);
           }
         });
  
                 v.addEventListener('loadedmetadata', function() {
           updatePlayPauseIcon();
           // Garantir que o estado de mute seja aplicado
           v.muted = isMuted;
         });

        // Eventos de pause/play
        v.addEventListener('pause', function() {
          updatePlayPauseIcon();
        });

                         v.addEventListener('play', function() {
          updatePlayPauseIcon();
          // Garantir que o estado de mute seja mantido durante a reprodução
          v.muted = isMuted;
        });

        // Event listener para quando o vídeo começar a tocar
        v.addEventListener('playing', function() {
          v.muted = isMuted;
        });

        // Prevenir autoplay quando pausado manualmente
        v.addEventListener('pause', function() {
          // Se foi pausado manualmente, não deixar autoplay
          if (videoEl && videoEl.paused) {
            videoEl.autoplay = false;
          }
        });

        // Adicionar evento de clique no wrapper do vídeo (único event listener)
        videoWrapper.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Verificar se o clique foi no vídeo ou no wrapper
          if (e.target === v || e.target === videoWrapper) {
            togglePlayPause();
          }
        });

        // Prevenir comportamento padrão do vídeo
        v.addEventListener('contextmenu', function(e) {
          e.preventDefault();
        });
  

  
                 if (shareBtn) {
           shareBtn.onclick = function() {
             if (st.share_url) window.open(st.share_url, '_blank');
           };
         }
  
        renderRelatedProduct(st.related_product_handle);
      }
  
      function renderRelatedProduct(handle) {
        relatedProduct.innerHTML = '';
        if (!handle) return;
        fetch('/products/' + handle + '.js')
          .then(r => r.json())
          .then(prod => {
            relatedProduct.innerHTML =
              '<a href="/products/' + prod.handle +
              '" class="related-product-card"><img src="' +
              prod.images[0] + '" alt="' + prod.title +
              '"><div><span class="title">' + prod.title +
              '</span><span class="price">' + Shopify.formatMoney(prod.price) +
              '</span></div></a>';
          });
      }
  
                    // Event listeners para controles
       if (volumeBtn) {
         volumeBtn.addEventListener('click', toggleVolume);
         var volumeSvg = volumeBtn.querySelector('svg');
         if (volumeSvg) {
           volumeSvg.addEventListener('click', function(e) {
             e.stopPropagation();
             toggleVolume();
           });
         }
       }
       
       if (playPauseBtn) {
         playPauseBtn.addEventListener('click', togglePlayPause);
         var playPauseSvg = playPauseBtn.querySelector('svg');
         if (playPauseSvg) {
           playPauseSvg.addEventListener('click', function(e) {
             e.stopPropagation();
             togglePlayPause();
           });
         }
       }

       // Event listeners para navegação
       if (navPrev) {
         navPrev.onclick = function() { 
           if (current > 0) {
             openStory(current - 1);
           } else {
             // Navegação circular: primeiro story -> último story
             openStory(stories.length - 1);
           }
         };
       }
       
       if (navNext) {
         navNext.onclick = function() { 
           if (current < stories.length - 1) {
             openStory(current + 1);
           } else {
             // Navegação circular: último story -> primeiro story
             openStory(0);
           }
         };
       }
  
      thumbs.forEach((btn, i) => btn.addEventListener('click', function() {
        openStory(i);
      }));
  
             if (closeBtn) {
         closeBtn.onclick = closeStory;
         
         // Adicionar event listener para o SVG dentro do botão de fechar
         var closeSvg = closeBtn.querySelector('svg');
         if (closeSvg) {
           closeSvg.addEventListener('click', function(e) {
             e.stopPropagation();
             closeStory();
           });
         }
       }
      overlay.addEventListener('click', function(e) {
        // Não fechar se clicar no vídeo ou wrapper do vídeo
        if (e.target === videoWrapper || e.target === videoEl || e.target.closest('.story-overlay__video-wrapper')) {
          return;
        }
        
        if (e.target === overlay || e.target === qs('.story-overlay__backdrop', overlay)) {
          closeStory();
        }
      });
  
             document.addEventListener('keydown', function(e) {
         if (overlay.style.display !== 'flex') return;
         if (e.key === 'Escape') closeStory();
         if (e.key === 'ArrowLeft') navPrev.click();
         if (e.key === 'ArrowRight') navNext.click();
         if (e.key === 'ArrowUp') navPrev.click(); // Navegação circular
         if (e.key === 'ArrowDown') navNext.click(); // Navegação circular
         if (e.key === 'm' || e.key === 'M') {
           toggleVolume();
         }
         if (e.key === ' ' || e.key === 'Space') {
           e.preventDefault();
           togglePlayPause();
         }
       });
  
      
      
             // Adicionar event listeners para os SVGs dos botões de navegação
       if (navPrev) {
         var navPrevSvg = navPrev.querySelector('svg');
         if (navPrevSvg) {
           navPrevSvg.addEventListener('click', function(e) {
             e.stopPropagation();
             if (current > 0) {
               openStory(current - 1);
             } else {
               // Navegação circular: primeiro story -> último story
               openStory(stories.length - 1);
             }
           });
         }
       }
       
       if (navNext) {
         var navNextSvg = navNext.querySelector('svg');
         if (navNextSvg) {
           navNextSvg.addEventListener('click', function(e) {
             e.stopPropagation();
             if (current < stories.length - 1) {
               openStory(current + 1);
             } else {
               // Navegação circular: último story -> primeiro story
               openStory(0);
             }
           });
         }
       }
    });
  })();
  